export default __webpack_public_path__ + "static/media/Medicalplanoptions.bf8d3dad.svg";